<template>
  <div class="h">
    <div class="content-tool-bar">
      链接：
      <a v-for="item in carouselList" :href="item.url" target="_blank">{{
        item.name
      }}</a>
      <!-- <a :href="carouselList[1].url" target="_blank">{{
        carouselList[1].name
      }}</a> -->
    </div>
  </div>
</template>

<script>
import util from "../utils/util";
export default {
  name: "ContentToolBar",
  data() {
    return {
      carouselList: [],
    };
  },
  created() {
    this.getFriendlyLinksData();
  },
  methods: {
    getFriendlyLinksData() {
      let Url = util.getAjaxUrl("axiosThree");
      this.$http.get(Url + "/api/getFriendlyLinks").then((resp) => {
        let datas = resp.data.data;
        console.log(datas[0].name);
        this.carouselList = datas;
      });
    },
  },
};
</script>


<style scoped lang="less">
@import "../styles/theme";
.h {
  /*width: 1200px !important;*/
  width: 1150px !important;
  margin: 0 auto;
}
.content-tool-bar {
  padding: 0.6rem 2rem;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  font-size: 14px;
  margin: auto 0;
  line-height: @height-tool-bar;

  a {
    padding: 0 .5rem;
    border-right: 1px black solid;
  }
  a:hover {
    color: @theme-color;
  }
  a:last-child{
    border-right: none;
  }
}
</style>
